module.exports = __webpack_public_path__ + "assets/img/ed8caf5736233dacd4a2b3445c9b179a.png";